import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  z-index: 2;
`;
